/*
 * Maps can be mutated, leading to poor ability to check equality, specifically in the use case of syncers
 * that expect referential equality. Instead of using ImmutableMap and suffering potential performance impacts,
 * MutationTrackingMap attempts to provide equality for cheap by tracking mutations.
 */
export default class MutationTrackingMap<K, V> extends Map<K, V> {
  private _equalityCounter: number = 0;

  override clear(): void {
    this._equalityCounter++;
    super.clear();
  }

  override delete(key: K): boolean {
    this._equalityCounter++;
    return super.delete(key);
  }

  override set(key: K, value: V): this {
    this._equalityCounter++;
    return super.set(key, value);
  }

  getCounter(): number {
    return this._equalityCounter;
  }
}
